import { jsx as t } from "react/jsx-runtime";
function i() {
  return /* @__PURE__ */ t("svg", { width: "20", height: "18", viewBox: "0 0 20 18", fill: "none", children: /* @__PURE__ */ t(
    "path",
    {
      d: "M14.6727 16.1686H16.3741L5.40432 1.73573H3.58086L14.6727 16.1686ZM15.7486 0H18.8151L12.1157 7.62646L20 18H13.8261L8.99119 11.7097L3.46077 18H0.395317L7.56005 9.84146L0 0H6.32706L10.6956 5.75123L15.7486 0Z",
      fill: "#0F1419"
    }
  ) });
}
export {
  i as default
};
